export const PLATFORMS = {
  WEB: 'ingameShop',
  STEAM: 'steam',
  WIN_STORE: 'winstore',
  EGS: 'egs',
};

export type Platform = typeof PLATFORMS[keyof typeof PLATFORMS];

export const DWH_PLATFORMS = {
  [PLATFORMS.WEB]: 'web',
  [PLATFORMS.STEAM]: 'steam',
  [PLATFORMS.WIN_STORE]: 'winstore',
  [PLATFORMS.EGS]: 'egs',
};
